/** Search parameters used in the manager page. */
export const searchParametersManager = {
    NAME: 'name',
}

/** Search parameters used in the manager API. */
export const searchParametersManagerApi = {
    HAS_ORDER: 'has_order',
    NAME: 'name__icontains',
}
